import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.nav.sidebar');
import { OnInit } from '@angular/core';
import { HostListener } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-component-nav-sidebar',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.nav.sidebar/view.scss */
/* src/app/component.nav.sidebar/view.scss: no such file or directory */`],
})
export class ComponentNavSidebarComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
    }

    @HostListener('document:click')
    public clickout() {
        this.service.status.toggle('navbar', true);
    }

    public isActive(link: string) {
        return location.pathname.indexOf(link) === 0
    }

    public isWorkspaceActive(tab: string) {
        if (tab === "work" && location.pathname.indexOf("/work") === 0) return true;
        if (location.pathname.indexOf("/dashboard") !== 0) return false;
        return new URLSearchParams(location.search).get("tab") === tab;
    }

    public activeClass(link: string) {
        if (this.isActive(link) && location.search === "") {
            return "group flex gap-x-2 items-center rounded-md bg-zinc-100 px-2 py-1.5 text-[13px] font-semibold text-zinc-950";
        }
        return "group flex gap-x-2 items-center rounded-md px-2 py-1.5 text-[13px] font-medium text-zinc-600 hover:bg-zinc-50 hover:text-zinc-950";
    }

    public workspaceClass(tab: string) {
        const base = "group flex gap-x-2 items-center rounded-md px-2 py-1.5 text-[13px] font-medium";
        if (this.isWorkspaceActive(tab)) {
            return `${base} bg-zinc-100 font-semibold text-zinc-950`;
        }
        return `${base} text-zinc-600 hover:bg-zinc-50 hover:text-zinc-950`;
    }
}

export default ComponentNavSidebarComponent;